export default "__VITE_ASSET__WNjZBlWd__"